export default "__VITE_ASSET__41a0a232__"